import { Card, Flex } from '@grupoboticario/flora-react';

import { Divider, Skeleton } from 'components';

import Styles from './ItemsAccordion.styles';

export const AccordionSkeleton = () => {
  return (
    <Styles.Wrapper direction='column' data-testid='skeleton-accordion' gap='$4'>
      <Card>
        <Flex gap='$4' direction='column'>
          <Divider variant='Line' />
          <Skeleton height='$5' width='100%' />
          <Styles.Grid gap='$5'>
            {[...Array(6)].map((_, index) => {
              return (
                <Styles.SkeletonItemCard key={`order-item-${index}`}>
                  <Flex direction='column' gap='$4'>
                    <Flex direction='row' gap='$4'>
                      <Skeleton height='$10' width='25%' />
                      <Skeleton height='$5' width='75%' />
                    </Flex>
                    <Skeleton width='100%' />
                    <Skeleton width='100%' />
                  </Flex>
                </Styles.SkeletonItemCard>
              );
            })}
          </Styles.Grid>
        </Flex>
      </Card>
    </Styles.Wrapper>
  );
};
